import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import API from "../Service/Baseservice";
import "../Admin/Admin.css";
import { Eye, EyeOff } from "lucide-react";
const AdminEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [emailError, setEmailError] = useState("");
  const adminData = location.state?.adminData || {};
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    admin_id: id,
    admin_name: adminData.admin_name || "",
    email: adminData.email || "",
    password: adminData.original_password || "",
    phone_number: adminData.phone_number || "",
    admin_image: adminData.admin_image || "",
    active: adminData.active || 1,
    createdBy: "1",
    updatedBy: "1",
  });

  const [previewImage, setPreviewImage] = useState(
    adminData.admin_image
      ? adminData.admin_image.startsWith("http")
        ? adminData.admin_image
        : `http://dev-service.asraimmigration.ca/backend_service/uploads/admin/${adminData.admin_image}`
      : null
  );


  const [popup, setPopup] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const uploadImage = (file, callback) => {
    if (!file) {
      callback(formData.admin_image);
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      const imageData = {
        name: "Admin Image",
        image: [
          {
            name: file.name,
            type: file.type,
            size: `${file.size} bytes`,
            base64: reader.result,
          },
        ],
      };

      API.post("imageUpload/add", imageData)
        .then((res) => {
          if (res.data?.success) {
            callback(res.data.url);
          } else {
            setPopup({
              show: true,
              title: "Error",
              message: "Image upload failed!",
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error("Image upload error:", err);
          setPopup({
            show: true,
            title: "Error",
            message: "Failed to upload image.",
            type: "error",
          });
        });
    };

    reader.readAsDataURL(file);
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.admin_name || !formData.email || !formData.password) {
      setPopup({
        show: true,
        title: "Warning",
        message: "Please fill all required fields.",
        type: "info",
      });
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(formData.email)) {
      setEmailError("Please enter a valid email address.");
      setPopup({
        show: true,
        title: "Warning",
        message: "Invalid email format.",
        type: "info",
      });
      return;
    } else {
      setEmailError("");
    }
    uploadImage(selectedFile, (uploadedImageUrl) => {
      const updatedData = {
        ...formData,
        admin_image: uploadedImageUrl,
      };

      API.post("admin_edit/update", updatedData)
        .then((res) => {
          setPopup({
            show: true,
            title: "Success",
            message: res.data?.message || "Admin updated successfully!",
            type: "success",
          });

          // setTimeout(() => navigate("/admin"), 2500);
        })
        .catch((err) => {
          console.error("Failed to update admin:", err);
          setPopup({
            show: true,
            title: "Error",
            message: "Failed to update admin. Please try again.",
            type: "error",
          });
        });
    });
  };

  return (
    <div className="admin-form-container">
      <div className="newsadd-header">
        <h2 className="newsadd-title">Edit Admin</h2>
        <div className="header-buttons">
          <button
            onClick={handleSubmit}
            className="btn saves-btn"
          >
            Update
          </button>
          <button onClick={() => navigate("/admin")} className="cancel-btn ">
            Back
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="admin-form-page">
        {/* ✅ Image Upload */}
        <div className="image-upload-container">
          <label htmlFor="admin_image" className="image-label">
            {previewImage ? (
              <img
                src={previewImage}
                alt="Preview"
                className="admin-image-preview"
              />
            ) : (
              <div className="image-placeholder">+</div>
            )}
          </label>
          <input
            type="file"
            id="admin_image"
            name="admin_image"
            accept="image/*"
            onChange={handleImageChange}
            style={{ display: "none" }}
          />
          <p className="image-note">Click the circle to upload image</p>
        </div>

        {/* ===== Row 1: Admin Name + Email ===== */}
        <div className="admin-form-row">
          <div className="admin-form-group">
            <label>Admin Name <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="admin_name"
              value={formData.admin_name}
              onChange={handleChange}
              placeholder="Enter admin name"
            />
          </div>
          <div className="admin-form-group">
            <label>
              Email <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              placeholder="Enter email"
              onChange={(e) => {
                const value = e.target.value;
                setFormData({ ...formData, email: value });


                const emailPattern = /^[^\s@]+@[^\s@]+\.com$/;
                if (value && !emailPattern.test(value)) {
                  setEmailError("Please enter a valid email address");
                } else {
                  setEmailError("");
                }
              }}
            />
            {/* ⚠️ Error Message */}
            {emailError && (
              <span style={{ color: "red", fontSize: "12px" }}>{emailError}</span>
            )}
          </div>
        </div>

        {/* ===== Row 2: Password + Phone Number ===== */}
        <div className="admin-form-row">
          <div className="admin-form-group">
            <label>
              Password <span style={{ color: "red" }}>*</span>
            </label>

            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                autoComplete="new-password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password"
              />
              <span
                className="password-toggle-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
          </div>
          <div className="admin-form-group">
            <label>
              Phone Number <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              name="phone_number"
              value={formData.phone_number}
              onChange={(e) => {
                const value = e.target.value;


                if (/^\d{0,10}$/.test(value)) {
                  setFormData({ ...formData, phone_number: value });
                }
              }}
              placeholder="Enter phone number"
            />
          </div>

        </div>
      </form>

      {/* Popup Modal */}
      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box ${popup.type}`}>
            <h3>{popup.title}</h3>
            <p>{popup.message}</p>
            <div className="popup-buttons">
              <button
                className="btn ok-btn"
                onClick={() => {
                  setPopup({ ...popup, show: false });

                  if (popup.type === "success") {
                    navigate("/admin"); // ✅ redirect ONLY on OK
                  }
                }}
              >
                OK
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminEdit;
